// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","mainContent":"Layout_mainContent__Bq4qw","content":"Layout_content__-XVhO","mobileContent":"Layout_mobileContent__jCpVc"};